import { render, staticRenderFns } from "./TeachingSituation.vue?vue&type=template&id=e23448c6&scoped=true"
import script from "./TeachingSituation.vue?vue&type=script&lang=ts"
export * from "./TeachingSituation.vue?vue&type=script&lang=ts"
import style0 from "./TeachingSituation.vue?vue&type=style&index=0&id=e23448c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23448c6",
  null
  
)

export default component.exports